export default __webpack_public_path__ + "static/media/2.69a6786b.png";